///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.item_maintenance_reports = abcsetup.item_maintenance_reports || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.item_maintenance_reports = {
    init: function() {
        abcsetup.setTitle('Item Maintenance Reports');

        // Init datatables
        abcsetup.datatables.client_side.init($('table#maintenance_reports'), {
            bInfo: true,
            "responsive": true,
            "dom": 'lftipB',
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 10,
            "order": [[4, "desc"]],
        });
    },
}
